<template>
  <div>
    <!--滑动15秒才能关闭弹窗-->
    <van-dialog
      v-model="visible"
      :showConfirmButton="false"
      class="custormTips4"
    >
      <p class="title">重要税务公告</p>
      <div class="t-content">
        <p class="name">尊敬的平台用户:</p>
        <div class="text-content" @scroll="handleScroll">
          根据<span style="color: #006EEF;" @click="open"
            >国家税务总局2025年第16号公告</span
          >要求，自2025年10月1日起，您在小鲲车服取得的收入，将由平台合作方按规定进行个人所得税预扣预缴及增值税代办申报。<br />
          具体说明<br />
          Q1.从什么时候开始预扣个税?<br />
          <div class="text-answer">
            A:根据政策要求，从2025年10月1日起开始预扣并于次月进行申报和预缴。<br />
          </div>
          Q2.个税是怎么计算的?<br />
          <div class="text-answer">
            A:应纳税所得金额=年累计收入金额x80%-5000元x连续收入月数，根据应纳税所得额按3%-45%的税率预缴个税。<span  style="color:red;">如每月收入都低于<strong style="font-size: large;">6250</strong>元，则不需要预扣个税。如月平均收入高于<strong style="font-size: large;">6250</strong>元，则按照以上方法预扣。</span>举例:服务人员6月收入7000元，7月收入7500元，那么每个月个税按照如下方法计算:6月:[7000x(1-20%)-5000]x3%=18元:7月:[(7000+7500)x(1-20%)-5000x2]x3%-18=30元;以此类推。注意:如果某个月未产生收入，再次获取收入时，重新累计全年收入总额和连续收入月数。<br />
          </div>
          Q3.在哪里可以看到缴税记录?<br />
          <div class="text-answer">
            A:手机端下载个人所得税APP，预扣税款后的次月下旬可以在APP上查询。<br />
          </div>
          Q4:我怎么查不到个税缴纳记录?<br />
          <div class="text-answer">
            A:预扣税款后的次月下旬可以在APP上查询。举例:10月预扣的个税，可以于11月下旬在个人所得税
            APP上查询。<br />
          </div>
          Q5.如何获取个人所得税纳税记录(原完税证明)?<br />
          <div class="text-answer">
            A:手机端下载&登录个人所得税APP，首页底部【办&查】模块，点击【纳税记录开具】，即可生成纳税记录(原完税证明)。<br />
          </div>
          Q6.我在平台上取得的收入能不能不缴纳个税?<br />
          <div class="text-answer">
            A:不能。为响应国家税务政策要求，自10月1日起平台合作方将对个人获取的收入按劳务报酬进行累计预扣税。此举是为更合规地履行代扣代缴义务请您理解。<br />
          </div>
          Q7.我在其他平台也有收入，会合并计税吗?<br />
          <div class="text-answer">
            A:每月预扣时不会，每月各平台会根据从业人员收入分别计算和预扣预缴个税。次年3-6月需个人在个人所得税APP上对各平台所有收入做汇算清缴。<strong>（每个月各个平台核算个税的时候不会合并计算，各个平台收入在月度是单独预扣交税，到第二年3-6月，由本人在个税APP上自行做年度汇算清缴，对所有平台收入做汇总核算，多退少补）</strong><br />
          </div>
          Q8.我的个税好像比以前扣的多了?<br />
          <div class="text-answer">
            A:当个人累计预扣预缴应纳所得额超过36000元后，预扣率会从3%变为10%。<br />
          </div>
          Q9.增值税如何处理?<br />
          <div class="text-answer">
            A:从业人员一个月度内一个或者多个平台合计收入少于小规模纳税人增值税免税标准(目前是10万元)的，免增值税。一个月度内自两个以上互联网平台企业取得服务收入合计超过小规模纳税人增值税免税标准(目前是10万元)的，于取得收入的次次月、按照约1.06%补缴增值税及附加。<br />
          </div>
        </div>
      </div>
      <div class="t-btns-box">
        <div
          class="t-btns"
          :class="{ disabled: countdown > 0 }"
          @click="handleClose"
        >
          {{
            countdown > 0
              ? `我已阅读税务公告(${countdown}s)`
              : "我已阅读税务公告"
          }}
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import config from "@/configs/config";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
      require: true
    },
    slideId: {
      type: Boolean,
      default: true,
      require: true
    }
  },
  data() {
    return {
      countdown: 0, //倒计时
      hasScrolled: false,
      timer: null //计时器
    };
  },
  watch: {
    // visible(val) {
    //   if (val) {
    //     // 重置状态
    //     this.hasScrolled = false;
    //     if (!this.slideId) {
    //       this.countdown = 15;
    //     }else{
    //        this.countdown = 0
    //     }
    //     clearInterval(this.timer);
    //   }
    // }
  },
  mounted() {
    if (this.visible) {
        // 重置状态
        this.hasScrolled = false;
        if (!this.slideId) {
          this.countdown = 15;
        }else{
           this.countdown = 0
        }
        clearInterval(this.timer);
      }
  },

  methods: {
    open() {
      location.href =
        "https://fgk.chinatax.gov.cn/zcfgk/c100012/c5241472/content.html";
      tuhu.localStorage.setItem("visibleSlidePop", 1);
    },
    // 处理滚动事件
    handleScroll() {
      if (!this.hasScrolled) {
        this.hasScrolled = true;
        this.startCountdown();
      }
    },

    // 初始化倒计时
    startCountdown() {
      if (!this.slideId) {
        this.timer = setInterval(() => {
          this.countdown -= 1;
          if (this.countdown <= 0) {
            clearInterval(this.timer);
          }
        }, 1000);
      } else {
        this.countdown = 0;
      }
    },
    // 处理关闭操作
    handleClose() {
      if (this.countdown > 0) return 
      if (this.countdown <= 0 && !this.slideId) {
        this.addUserNotice(1);
      }
      tuhu.localStorage.setItem("visibleSlidePop", 2);
      this.$emit("close");
    },
    async getUserInfo() {
      // 身份信息
      const res = await tuhu.fetch(`${config.apis.GET_USERINFO}`);
      if (res && res.code === "200") {
        const userInfoPromise = tuhu._setUserInfo(res.data); // 返回数据
        if (this.options && this.options.resolve) {
          this.options.resolve(userInfoPromise);
        }
      } else {
        tuhu.toast(res.message || "获取权限信息失败");
      }
    },
    //用户看过某个公告
    async addUserNotice(type) {
      try {
        let formdata = new FormData();
        formdata.append("type", type); // 文件对象
        const data = await tuhu.fetch(`${config.apis.ADD_USER_NOTICE}`, {
          method: "post",
          body: new URLSearchParams({
            type: type
          }),
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        });
        if (data.code === "200") {
          await this.getUserInfo();
        } else {
          tuhu.toast(data.message);
        }
      } catch (error) {
        console.log("err", error);
        tuhu.toast(error);
      }
    }
  }
};
</script>

<style scoped lang="less">
.custormTips4 {
  width: 16rem;
  height: 25rem;
  background: url("https://res.xiaokunkeji.cn/image/2023/12/12/3be777a1fa0846b68f11c88960bd7433.png")
    no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  .title {
    height:1.8rem;
    line-height: 1.8rem;
    font-size: 1.8rem;
    color: #aa6928;
    margin-top: 2.3rem;
    margin-left: 0.8rem;
  }

  .t-content {
    height: 16rem;
    padding: 0 1rem;
    font-size: 0.7rem;
    font-weight: 500;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #333333;
    .text-content {
      height: 13rem;
      font-size: 0.8rem;
      overflow-y: scroll;
      line-height: 1.2rem;
      .text-answer {
        width: 14rem;
        background-color: #f5f5f5;
        color: #808080;
        border-radius: 0.5rem;
        padding: 0.5rem;
        margin-bottom: 0.5rem;
      }
    }

    .name {
      height:0.8rem;
      font-size: 0.8rem;
      width: 14rem;
      text-align: left;
      margin: 1.5rem 0 0.4rem 0;
    }

    .service-provider {
      text-align: right;
      margin-top: 1rem;
    }
  }
  .t-btns-box{
    width: 16rem;
    height: 3rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 1rem;
    margin-bottom: 0.5rem;
    .t-btns {
      background: url("../../../imgs/t-btn-null.png") no-repeat;
      background-size: 100% 100%;
      width: 14rem;
      height: 3rem;
      line-height: 1.5rem;
      margin: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      color: white;
      font-size: 0.8rem;
      font-weight: bold;
    }
    .t-btns.disabled {
      border-radius: 0.25rem;
      background: url("../../../imgs/t-btn-gray.png") no-repeat;
      background-size: 100% 100%;
      cursor: not-allowed;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/sildePopup.vue